import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Logo, ThemeToggle, Footer, Eyebrow } from "@/components/sg/Brand";
import { FaqList } from "@/components/sg/FaqList";
import { SupportChat } from "@/components/sg/SupportChat";

export function HelpCenter() {
  const { user } = useAuth();
  return (
    <div className="grid lg:grid-cols-12 gap-8">
      <div className="lg:col-span-7">
        <Eyebrow>Help center</Eyebrow>
        <h1 className="font-display text-3xl font-bold mt-3 mb-6">Frequently asked questions</h1>
        <FaqList />
      </div>
      <div className="lg:col-span-5 lg:sticky lg:top-24 self-start">
        {user ? <SupportChat /> : (
          <div className="border border-border rounded-xl bg-card p-6" data-testid="support-signin-cta">
            <div className="font-display font-bold text-lg">Need a hand?</div>
            <p className="text-sm text-muted-foreground mt-2">Sign in to chat with the ScopeGuard support assistant or reach a human.</p>
            <Link to="/auth"><Button className="mt-4 bg-indigo-600 hover:bg-indigo-500 text-white">Sign in for support</Button></Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default function FaqPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between"><Logo /><ThemeToggle /></div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-12"><HelpCenter /></main>
      <Footer />
    </div>
  );
}
